import { Component, input, output } from '@angular/core';
import {
    AixProductCardComponent,
    ProductCardSelection,
    ProductRecord
} from '@trade-platform/ui-shared';

import { ProductsPipe } from '@advisor-ui/app-components';

@Component({
    selector: 'aix-product-container-list',
    templateUrl: './product-container-list.component.html',
    styleUrls: ['./product-container-list.component.scss'],
    standalone: true,
    imports: [AixProductCardComponent, ProductsPipe]
})
export class AixProductContainerListComponent {
    cards = input<ProductRecord[]>();
    productSearchText = input<string>();
    productCardLanguage = input<{ notificationText: string }>();

    productCardSelected = output<ProductCardSelection>();

    productCardFavorite = output<ProductRecord>();

    constructor() {}

    favoriteCard(card: ProductRecord) {
        this.productCardFavorite.emit(card);
    }

    productCardSelect(e: ProductCardSelection) {
        this.productCardSelected.emit(e);
    }
}
